const base = function() {
  if (process.env.NODE_ENV === "development") {
    return "https://dev.api.alber.solutionplus.net";
  } else if (process.env.NODE_ENV === "online_dev") {
    return "https://dev.api.alber.solutionplus.net";
  } else if (process.env.NODE_ENV === "testing") {
    return "https://dev.api.alber.solutionplus.net";
  } else if (process.env.NODE_ENV === "production") {
    return "https://api.beralula.org.sa";
  }
};
export const baseURL = base();
